import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupCreatePage } from './shopper-social-group-create';

@NgModule({
  declarations: [
    ShopperSocialGroupCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupCreatePage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-create/shopper-social-group-create.module.ts